<template>
  <div class="smy__card-full-box">
    <Card
      :bordered="false"
      style="margin-bottom:10px">
      <div class="accountRemant">
        <div class="left">
          账户余额：{{'￥' + accountDetail.account_price}}
        </div>
        <div class="right">
          <Button
            type="primary"
            class="search-button"
            style="margin-left:10px;"
            @click="editListModal = true"
          >充值</Button>
        </div>
      </div>
    </Card>
    <Card :bordered="false">
      <div class="top">
        <ButtonGroup>
          <Button type="primary"
            v-for="(item, index) in typeNameList"
            :key="item.type"
            :type="searchForm.state == item.type ? 'primary' : 'ghost'"
            @click="searchForm.state = item.type"
          >{{item.name}}</Button>
        </ButtonGroup>
      </div>
      <div class="table" style="margin:17px 0">
        <Table
          v-show="searchForm.state === -1"
          stripe
          ref="table"
          :loading="listLoading"
          :columns="LiuColumns"
          :data="list"
        />
        <Page
          v-show="searchForm.state === -1"
          show-total
          show-sizer
          class="page"
          placement="top"
          style="margin-top:17px;"
          :current="pageIndex_c + 1"
          :total="count"
          :page-size-opts="pageSizeOpts"
          @on-change="pageIndexChange($event, 'cashflow')"
          @on-page-size-change="pageSizeChange($event, 'cashflow')"
        />
        <Table
          stripe
          v-show="searchForm.state === 0"
          ref="table"
          :loading="listLoading"
          :columns="columns"
          :data="rechargeList"
        />
        <Page
          v-show="searchForm.state === 0"
          show-total
          show-sizer
          style="margin-top:17px;"
          class="page"
          placement="top"
          :current="pageIndex + 1"
          :total="rechargeCount"
          :page-size-opts="pageSizeOpts"
          @on-change="pageIndexChange($event, 'recharge')"
          @on-page-size-change="pageSizeChange($event, 'recharge')"
        />
      </div>
    </Card>
    <PicsModal
      :pics="picList"
      :visible="picModel"
      :index="picIndex"
      @on-close="picModel = false"
    />
    <AgAgentRechargeModal
      v-model="editListModal"
      @on-success="reload()"
    />
  </div>
</template>

<script>
import {mapState} from 'vuex'

import PicsModal from '@/components/PicsModal'
import AgAgentRechargeModal from './AgAgentRechargeModal'

export default {
  components: {
    PicsModal,
    AgAgentRechargeModal
  },
  data () {
    return {
      pageSize: 10,
      pageIndex: 0,
      pageSize_c: 10,
      pageIndex_c: 0,
      list: [],
      count: 0,
      rechargeList: [],
      rechargeCount: 0,
      accountDetail: {},
      picModel: false,
      picIndex: 0,
      picList: [],
      listLoading: false,
      searchForm: {
        state: -1
      },
      editListModal: false,
      typeNameList: [{
        type: -1,
        name: '流水记录'
      }, {
        type: 0,
        name: '充值记录'
      }]
    }
  },
  computed: {
    ...mapState('table', [
      'pageSizeOpts'
    ]),
    LiuColumns () {
      const allColumns = [
        {
          title: '操作时间',
          key: 'create_time',
          width: 180
        },
        {
          title: '操作',
          width: 140,
          render: (h, {row}) => {
            let priority = row.price_type
            let priorityName = ''
            if (priority === 101) {
              priorityName = '充值'
            } else if (priority === 102) {
              priorityName = '下单'
            } else {
              priorityName = '退单'
            }
            return h('span', [priorityName])
          }
        },
        {
          title: '金额',
          key: 'price',
          width: 140,
          render: (h, {row}) => {
            let add = ''
            if (row.type === 1) {
              add = '+'
            } else {
              add = '-'
            }
            return h('span', [add + row.price])
          }
        },
        {
          title: ' ',
          key: ' '
        }
      ]
      return allColumns
    },
    // 表格列 根据选中的列动态生成
    columns () {
      const allColumns = [
        {
          title: '操作时间',
          key: 'create_time',
          width: 180
        },
        {
          title: '操作',
          width: 140,
          render: (h, {row}) => {
            let priority = row.type
            let priorityName = ''
            if (priority === 1) {
              priorityName = '充值'
            } else if (priority === 2) {
              priorityName = '升级'
            }
            return h('span', [priorityName])
          }
        },
        {
          title: '金额',
          key: 'price',
          width: 140
        },
        {
          title: '流水账号',
          key: 'flow_no',
          width: 140
        },
        {
          title: '付款凭证图片',
          width: 140,
          align: 'center',
          render: (h, { row }) => {
            let check = h('Button', {
              props: {
                type: 'ghost',
                size: 'small'
              },
              on: {
                click: () => {
                  this.picIndex = this.index
                  this.picList = row.img_urls ? row.img_urls.split(',') : []
                  this.picModel = true
                }
              }
            }, ['查看'])
            return h('span', [check])
          }
        },
        {
          title: '处理状态',
          width: 100,
          align: 'handle_state',
          render: (h, { row }) => {
            if (row.handle_state === 1) return '未处理'
            if (row.handle_state === 2) return '已处理'
            return ''
          }
        },
        {
          title: ' ',
          key: ' '
        }
      ]
      return allColumns
    }
  },
  methods: {
    loadList () {
      this.listLoading = true
      this.$http.all([
        this.$http.get('/agent/account/recharge/list', {
          params: {
            type: 1,
            pageIndex: this.pageIndex,
            pageSize: this.pageSize
          }
        }),
        this.$http.get('/agent/account/recharge/count?type=1')
      ]).then(this.$http.spread((res1, res2) => {
        if (res1.data) this.rechargeList = res1.data
        this.rechargeCount = res2.data
        this.listLoading = false
      }))
    },
    getAccountInfo () {
      this.$http.get('/agent/account/info').then(res => {
        this.accountDetail = res.data
      })
    },
    getCashflowList () {
      this.$http.all([
        this.$http.get('/agent/account/cashflow/list', {
          params: {
            pageIndex: this.pageIndex_c,
            pageSize: this.pageSize_c
          }
        }),
        this.$http.get('/agent/account/cashflow/count')
      ]).then(this.$http.spread((res1, res2) => {
        if (res1.data) this.list = res1.data
        this.count = res2.data
        this.listLoading = false
      }))
    },
    pageSizeChange (pageSize, value) {
      if (value === 'recharge') {
        this.pageSize = pageSize
        this.loadList()
      } else if (value === 'cashflow') {
        this.pageSize_c = pageSize
        this.getCashflowList()
      }
    },
    // 分页 页码 改变回调
    pageIndexChange (pageIndex, value) {
      if (value === 'recharge') {
        this.pageIndex = (pageIndex - 1)
        this.loadList()
      } else if (value === 'cashflow') {
        this.pageIndex_c = (pageIndex - 1)
        this.getCashflowList()
      }
    },
    reload () {
      this.loadList()
      this.getCashflowList()
      this.getAccountInfo()
    }
  },
  created () {
    this.reload()
  }
}
</script>

<style lang="less" scoped>
.accountRemant{
  display: flex;
  .left{
    width: 300px;
    flex-shrink: 0;
  }
  .right{
    width: 100%;
    text-align: right;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/agentManage/agAgentManage/AgentManageRight.vue